import { render, staticRenderFns } from "./TypePaymentsTable.vue?vue&type=template&id=55c3cb07&scoped=true&"
import script from "./TypePaymentsTable.vue?vue&type=script&lang=js&"
export * from "./TypePaymentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c3cb07",
  null
  
)

export default component.exports